import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import { css, jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import ButtonGroup from '@atlaskit/button/button-group';
import { areSameItems, messages } from '@atlaskit/editor-common/floating-toolbar';
import { Announcer, FloatingToolbarButton as Button } from '@atlaskit/editor-common/ui';
import { backgroundPaletteTooltipMessages } from '@atlaskit/editor-common/ui-color';
import { ColorPickerButton, ToolbarArrowKeyNavigationProvider } from '@atlaskit/editor-common/ui-menu';
import { hexToEditorBackgroundPaletteColor } from '@atlaskit/editor-palette';
import { clearHoverSelection } from '@atlaskit/editor-plugin-table/commands';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { checkShouldForceFocusAndApply, forceFocusSelector } from '../pm-plugins/force-focus';
import { showConfirmDialog } from '../pm-plugins/toolbar-data/commands';
import Dropdown from './Dropdown';
import { EmojiPickerButton } from './EmojiPickerButton';
import { ExtensionsPlaceholder } from './ExtensionsPlaceholder';
import Input from './Input';
import { ScrollButtons } from './ScrollButtons';
import Select from './Select';
import Separator from './Separator';
export function groupItems(items) {
  var groupItems = items.reduce(function (accumulator, item, i) {
    var finalOutput = accumulator.finalOutput,
      buttonGroup = accumulator.buttonGroup;
    if (item.type === 'button') {
      var notLastItem = i < items.length - 1;
      var nextItemIsButton = items[i + 1] && items[i + 1].type === 'button';
      var wasPreviousButton = items[i - 1] && items[i - 1].type === 'button';
      var isRadioButton = notLastItem && nextItemIsButton || wasPreviousButton;
      if (isRadioButton) {
        item.isRadioButton = true;
        buttonGroup.push(item);
        if (!nextItemIsButton && wasPreviousButton) {
          finalOutput.push(buttonGroup);
          accumulator.buttonGroup = [];
        }
      } else {
        finalOutput.push(item);
      }
    } else {
      finalOutput.push(item);
    }
    return accumulator;
  }, {
    buttonGroup: [],
    finalOutput: []
  });
  return groupItems.finalOutput;
}
var ToolbarItems = /*#__PURE__*/React.memo(function (_ref) {
  var items = _ref.items,
    dispatchCommand = _ref.dispatchCommand,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    editorView = _ref.editorView,
    dispatchAnalyticsEvent = _ref.dispatchAnalyticsEvent,
    popupsScrollableElement = _ref.popupsScrollableElement,
    scrollable = _ref.scrollable,
    providerFactory = _ref.providerFactory,
    extensionsProvider = _ref.extensionsProvider,
    node = _ref.node,
    setDisableScroll = _ref.setDisableScroll,
    mountRef = _ref.mountRef,
    api = _ref.api;
  var emojiAndColourPickerMountPoint = scrollable ? popupsMountPoint || (editorView === null || editorView === void 0 ? void 0 : editorView.dom.closest('.fabric-editor-popup-scroll-parent')) || (editorView === null || editorView === void 0 ? void 0 : editorView.dom.closest('.ak-editor-content-area')) || undefined : popupsMountPoint;
  var renderItem = function renderItem(item, idx) {
    var _api$contextPanel, _api$extension;
    switch (item.type) {
      case 'button':
        var ButtonIcon = item.icon;
        var onClickHandler = function onClickHandler() {
          if (item.confirmDialog) {
            dispatchCommand(showConfirmDialog(idx));
          } else {
            dispatchCommand(item.onClick);
            if (item.focusEditoronEnter && !(editorView !== null && editorView !== void 0 && editorView.hasFocus())) {
              editorView === null || editorView === void 0 || editorView.focus();
            }
          }
        };
        return jsx(Button, {
          className: item.className,
          key: idx,
          title: item.title,
          href: item.href,
          icon: item.icon ? jsx(ButtonIcon, {
            label: item.title
          }) : undefined,
          appearance: item.appearance,
          target: item.target,
          onClick: onClickHandler,
          onMouseEnter: function onMouseEnter() {
            return dispatchCommand(item.onMouseEnter);
          },
          onMouseLeave: function onMouseLeave() {
            return dispatchCommand(item.onMouseLeave);
          },
          onFocus: function onFocus() {
            return dispatchCommand(item.onFocus);
          },
          onBlur: function onBlur() {
            return dispatchCommand(item.onBlur);
          },
          selected: item.selected,
          disabled: item.disabled,
          tooltipContent: item.tooltipContent,
          testId: item.testId,
          hideTooltipOnClick: item.hideTooltipOnClick,
          ariaHasPopup: item.ariaHasPopup,
          tabIndex: item.tabIndex,
          isRadioButton: item.isRadioButton
        }, item.showTitle && item.title);
      case 'input':
        return jsx(Input, {
          key: idx,
          mountPoint: popupsMountPoint,
          boundariesElement: popupsBoundariesElement,
          defaultValue: item.defaultValue,
          placeholder: item.placeholder,
          onSubmit: function onSubmit(value) {
            return dispatchCommand(item.onSubmit(value));
          },
          onBlur: function onBlur(value) {
            return dispatchCommand(item.onBlur(value));
          }
        });
      case 'custom':
        {
          return item.render(editorView, idx, dispatchAnalyticsEvent);
        }
      case 'dropdown':
        var DropdownIcon = item.icon;
        return jsx(Dropdown, {
          key: idx,
          title: item.title,
          icon: DropdownIcon && jsx(DropdownIcon, {
            label: item.title
          }),
          dispatchCommand: dispatchCommand,
          options: item.options,
          disabled: item.disabled,
          tooltip: item.tooltip,
          hideExpandIcon: item.hideExpandIcon,
          mountPoint: popupsMountPoint,
          boundariesElement: popupsBoundariesElement,
          scrollableElement: popupsScrollableElement,
          dropdownWidth: item.dropdownWidth,
          showSelected: item.showSelected,
          buttonTestId: item.testId,
          editorView: editorView,
          setDisableParentScroll: scrollable ? setDisableScroll : undefined,
          dropdownListId: (item === null || item === void 0 ? void 0 : item.id) && "".concat(item.id, "-dropdownList"),
          alignDropdownWithToolbar: items.length === 1,
          onToggle: item.onToggle
        });
      case 'select':
        if (item.selectType === 'list') {
          var ariaLabel = item.title || item.placeholder;
          return jsx(Select, {
            key: idx,
            dispatchCommand: dispatchCommand,
            options: item.options,
            hideExpandIcon: item.hideExpandIcon,
            mountPoint: scrollable ? mountRef.current : undefined,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            defaultValue: item.defaultValue,
            placeholder: item.placeholder,
            onChange: function onChange(selected) {
              return dispatchCommand(item.onChange(selected));
            },
            ariaLabel: ariaLabel,
            filterOption: item.filterOption,
            setDisableParentScroll: scrollable ? setDisableScroll : undefined,
            classNamePrefix: 'floating-toolbar-select'
          });
        }
        if (item.selectType === 'color') {
          return jsx(ColorPickerButton, {
            skipFocusButtonAfterPick: true,
            key: idx,
            isAriaExpanded: item.isAriaExpanded,
            title: item.title,
            onChange: function onChange(selected) {
              dispatchCommand(item.onChange(selected));
            },
            colorPalette: item.options,
            currentColor: item.defaultValue ? item.defaultValue.value : undefined,
            placement: "Panels",
            mountPoint: emojiAndColourPickerMountPoint,
            setDisableParentScroll: scrollable ? setDisableScroll : undefined
            // Currently in floating toolbar, color picker is only
            //  used in panel and table cell background color.
            // Both uses same color palette.
            // That's why hard-coding hexToEditorBackgroundPaletteColor
            //  and paletteColorTooltipMessages.
            // When we need to support different color palette
            //  in floating toolbar, we need to set hexToPaletteColor
            //  and paletteColorTooltipMessages in item options.
            ,
            hexToPaletteColor: hexToEditorBackgroundPaletteColor,
            paletteColorTooltipMessages: backgroundPaletteTooltipMessages
          });
        }
        if (item.selectType === 'emoji') {
          return jsx(EmojiPickerButton, {
            key: idx,
            editorView: editorView,
            title: item.title,
            providerFactory: providerFactory,
            isSelected: item.selected,
            onChange: function onChange(selected) {
              return dispatchCommand(item.onChange(selected));
            },
            mountPoint: emojiAndColourPickerMountPoint,
            setDisableParentScroll: scrollable ? setDisableScroll : undefined
          });
        }
        return null;
      case 'extensions-placeholder':
        if (!editorView || !extensionsProvider) {
          return null;
        }
        return jsx(ExtensionsPlaceholder, {
          key: idx,
          node: node,
          editorView: editorView,
          extensionProvider: extensionsProvider,
          separator: item.separator,
          applyChangeToContextPanel: api === null || api === void 0 || (_api$contextPanel = api.contextPanel) === null || _api$contextPanel === void 0 ? void 0 : _api$contextPanel.actions.applyChange,
          extensionApi: api === null || api === void 0 || (_api$extension = api.extension) === null || _api$extension === void 0 ? void 0 : _api$extension.actions.api()
        });
      case 'separator':
        return jsx(Separator, {
          key: idx
        });
    }
  };
  if (getBooleanFF('platform.editor.a11y-floating-toolbar-markup_vexmo')) {
    var groupedItems = groupItems(items.filter(function (item) {
      return !item.hidden;
    }));
    return jsx(ButtonGroup, null, groupedItems.map(function (element, index) {
      var isGroup = Array.isArray(element);
      if (isGroup) {
        return jsx("div", {
          key: index,
          css: buttonGroupStyles,
          role: "radiogroup"
        }, element.map(function (item, idx) {
          return renderItem(item, idx);
        }));
      } else {
        return renderItem(element, index);
      }
    }));
  } else {
    return jsx(ButtonGroup, null, items.filter(function (item) {
      return !item.hidden;
    }).map(function (item, index) {
      return renderItem(item, index);
    }));
  }
}, function (prevProps, nextProps) {
  if (!nextProps.node) {
    return false;
  }
  // only rerender toolbar items if the node is different
  // otherwise it causes an issue where multiple popups stays open
  return !(prevProps.node.type !== nextProps.node.type || prevProps.node.attrs.localId !== nextProps.node.attrs.localId || !areSameItems(prevProps.items, nextProps.items) || !prevProps.mounted !== !nextProps.mounted);
});
var buttonGroupStyles = css({
  display: 'flex',
  gap: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var toolbarContainer = function toolbarContainer(scrollable, hasSelect, firstElementIsSelect) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  display: flex;\n  line-height: 1;\n  box-sizing: border-box;\n\n  & > div > div {\n    align-items: center;\n  }\n  ", "\n"])), "var(--ds-surface-overlay, white)", "var(--ds-border-radius, 3px)", "var(--ds-shadow-overlay, ".concat("0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25)", ")"), scrollable ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        ", "\n        overflow: hidden;\n      "])), hasSelect ? css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n              height: 40px;\n            "]))) : css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n              height: 32px;\n            "])))) : css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        padding: ", " ", ";\n        ", "\n      "])), "var(--ds-space-050, 4px)", "var(--ds-space-100, 8px)", firstElementIsSelect && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          padding-left: ", ";\n        "])), "var(--ds-space-050, 4px)")));
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var toolbarOverflow = function toolbarOverflow(scrollable, scrollDisabled, firstElementIsSelect) {
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), scrollable ? css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n        ", "\n        -webkit-overflow-scrolling: touch;\n        padding: ", " 0 ", ";\n        > div {\n          > div:first-child {\n            ", "\n          }\n          > div:last-child {\n            margin-right: ", ";\n          }\n        }\n      "])), scrollDisabled ? css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n              overflow: hidden;\n            "]))) : css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n              overflow-x: auto;\n              overflow-y: hidden;\n            "]))), "var(--ds-space-050, 4px)", "var(--ds-space-600, 48px)", firstElementIsSelect ? css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n                  margin-left: ", ";\n                "])), "var(--ds-space-050, 4px)") : css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n                  margin-left: ", ";\n                "])), "var(--ds-space-100, 8px)"), "var(--ds-space-100, 8px)") : css({
    display: 'flex'
  }));
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var Toolbar = /*#__PURE__*/function (_Component) {
  _inherits(Toolbar, _Component);
  var _super = _createSuper(Toolbar);
  function Toolbar(props) {
    var _this;
    _classCallCheck(this, Toolbar);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "shouldHandleArrowKeys", function () {
      var _this$props$items;
      //To prevent the keydown handling of arrow keys for custom toolbar items with 'disableArrowNavigation' prop enabled,
      //Usually the button which has menus or popups
      return !((_this$props$items = _this.props.items) !== null && _this$props$items !== void 0 && _this$props$items.find(function (item) {
        return item.type === 'custom' && item.disableArrowNavigation;
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "handleEscape", function (event) {
      var _this$props$editorVie;
      // If any menu is open inside the floating toolbar 'Esc' key should not
      // focus the editorview.
      // Event can't be stopped as they are not childnodes of floating toolbar

      var isDropdownOpen = !!document.querySelector('[data-role="droplistContent"]');
      var isSelectMenuOpen = !!document.querySelector('.floating-toolbar-select__menu');
      if (isDropdownOpen || isSelectMenuOpen) {
        return;
      }
      (_this$props$editorVie = _this.props.editorView) === null || _this$props$editorVie === void 0 || _this$props$editorVie.focus();
      event.preventDefault();
      event.stopPropagation();
    });
    _this.scrollContainerRef = /*#__PURE__*/React.createRef();
    _this.mountRef = /*#__PURE__*/React.createRef();
    _this.toolbarContainerRef = /*#__PURE__*/React.createRef();
    _this.state = {
      scrollDisabled: false,
      mounted: false
    };
    return _this;
  }
  // remove any decorations added by toolbar buttons i.e danger and selected styling
  // this prevents https://product-fabric.atlassian.net/browse/ED-10207
  _createClass(Toolbar, [{
    key: "resetStyling",
    value: function resetStyling(_ref2) {
      var table = _ref2.table;
      if (this.props.editorView) {
        var _this$props$api;
        var _this$props$editorVie2 = this.props.editorView,
          state = _this$props$editorVie2.state,
          dispatch = _this$props$editorVie2.dispatch;
        if (table) {
          return clearHoverSelection()(state, dispatch);
        }
        (_this$props$api = this.props.api) === null || _this$props$api === void 0 || (_this$props$api = _this$props$api.decorations) === null || _this$props$api === void 0 || _this$props$api.actions.removeDecoration(state, dispatch);
      }
    }
  }, {
    key: "setDisableScroll",
    value: function setDisableScroll(disabled) {
      var _this2 = this;
      // wait before setting disabled state incase users jumping from one popup to another
      if (disabled) {
        requestAnimationFrame(function () {
          _this2.setState({
            scrollDisabled: disabled
          });
        });
      } else {
        this.setState({
          scrollDisabled: disabled
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props;
      checkShouldForceFocusAndApply((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.editorView);
      if (this.props.node !== prevProps.node) {
        this.resetStyling({
          table: (prevProps === null || prevProps === void 0 ? void 0 : prevProps.node.type.name) === 'table'
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var editorView = this.props.editorView;
      if (editorView) {
        var tr = editorView.state.tr,
          dispatch = editorView.dispatch;
        dispatch(forceFocusSelector(null)(tr));
      }
      this.resetStyling({
        table: this.props.node.type.name === 'table'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        items = _this$props2.items,
        className = _this$props2.className,
        node = _this$props2.node,
        intl = _this$props2.intl,
        scrollable = _this$props2.scrollable,
        mediaAssistiveMessage = _this$props2.mediaAssistiveMessage;
      if (!items || !items.length) {
        return null;
      }

      // Select has left padding of 4px to the border, everything else 8px
      var firstElementIsSelect = items[0].type === 'select';
      var hasSelect = items.find(function (item) {
        return item.type === 'select' && item.selectType === 'list';
      });
      var isShortcutToFocusToolbar = function isShortcutToFocusToolbar(event) {
        //Alt + F10 to reach first element in this floating toolbar
        return event.altKey && (event.key === 'F10' || event.keyCode === 121);
      };
      return jsx(React.Fragment, null, jsx(ToolbarArrowKeyNavigationProvider, {
        editorView: this.props.editorView,
        handleEscape: this.handleEscape,
        disableArrowKeyNavigation: !this.shouldHandleArrowKeys(),
        childComponentSelector: "[data-testid='editor-floating-toolbar']",
        isShortcutToFocusToolbar: isShortcutToFocusToolbar,
        intl: intl
      }, jsx("div", {
        ref: this.toolbarContainerRef,
        css: function css() {
          return [toolbarContainer(scrollable, hasSelect !== undefined, firstElementIsSelect)];
        },
        "aria-label": intl.formatMessage(messages.floatingToolbarAriaLabel),
        role: "toolbar",
        "data-testid": "editor-floating-toolbar",
        className: className
      }, jsx(Announcer, {
        text: mediaAssistiveMessage ? "".concat(mediaAssistiveMessage, ", ").concat(intl.formatMessage(messages.floatingToolbarAnnouncer)) : intl.formatMessage(messages.floatingToolbarAnnouncer),
        delay: 250
      }), jsx("div", {
        "data-testid": "floating-toolbar-items",
        ref: this.scrollContainerRef
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        ,
        css: toolbarOverflow(scrollable, this.state.scrollDisabled, firstElementIsSelect)
      }, jsx(ToolbarItems, _extends({}, this.props, {
        setDisableScroll: this.setDisableScroll.bind(this),
        mountRef: this.mountRef,
        mounted: this.state.mounted
      }))), scrollable && jsx(ScrollButtons, {
        intl: intl,
        scrollContainerRef: this.scrollContainerRef,
        node: node,
        disabled: this.state.scrollDisabled
      })), jsx("div", {
        ref: this.mountRef
      })));
    }
  }]);
  return Toolbar;
}(Component);
export default injectIntl(Toolbar);